export default __webpack_public_path__ + "src/public/forward_to_inbox.svg";